import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { HomeIcon, TargetIcon, ChevronDownIcon, ChevronRightIcon, FolderIcon, BookOpenIcon, PlayIcon, BrainIcon, WrenchIcon, BuildingIcon, UsersIcon, MessageSquareIcon, SettingsIcon, PlugIcon, MenuIcon, XIcon } from 'lucide-react';
const menuSections = [{
  title: 'Dashboard',
  icon: HomeIcon,
  path: '/',
  subItems: []
}, {
  title: 'GTM Studio',
  icon: TargetIcon,
  path: '/gtm-studio',
  subItems: [{
    label: 'Workspace',
    path: '/gtm-studio/workspace'
  }, {
    label: 'Accounts',
    path: '/gtm-studio/accounts'
  }]
}, {
  title: 'Programs',
  icon: FolderIcon,
  path: '/programs',
  subItems: []
}, {
  title: 'Playbooks',
  icon: BookOpenIcon,
  path: '/playbooks',
  subItems: []
}, {
  title: 'Plays',
  icon: PlayIcon,
  path: '/plays',
  subItems: [{
    label: 'Library',
    path: '/plays/library'
  }, {
    label: 'Configuration',
    path: '/plays/configuration'
  }, {
    label: 'Journey Map',
    path: '/plays/journey-map'
  }, {
    label: 'Workflow',
    path: '/plays/workflow'
  }, {
    label: 'Editor',
    path: '/plays/editor'
  }, {
    label: 'Kanban',
    path: '/plays/kanban'
  }]
}, {
  title: 'Forecast',
  icon: TargetIcon,
  path: '/forecast',
  subItems: []
}, {
  title: 'Plan Builder',
  icon: FolderIcon,
  path: '/plan-builder',
  subItems: []
}, {
  title: 'Configuration',
  icon: BrainIcon,
  path: '/configuration',
  subItems: [{
    label: 'Tools',
    path: '/configuration/tools'
  }, {
    label: 'Partner Portals',
    path: '/configuration/partner-portals'
  }, {
    label: 'Collaboration',
    path: '/configuration/collaboration'
  }, {
    label: 'Community',
    path: '/configuration/community'
  }, {
    label: 'AI Config',
    path: '/configuration/ai-config'
  }, {
    label: 'Integrations',
    path: '/configuration/integrations'
  }]
}];
export function LeftNavigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const [expandedSections, setExpandedSections] = useState<string[]>(['plays', 'configuration']);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const toggleSection = (sectionTitle: string) => {
    setExpandedSections(prev => prev.includes(sectionTitle) ? prev.filter(title => title !== sectionTitle) : [...prev, sectionTitle]);
  };
  const NavigationContent = () => <>
      {/* Logo */}
      <div className="px-6 py-5 border-b border-gray-200" data-id="element-1990">
        <div className="flex items-center gap-3" data-id="element-1991">
          <div className="w-10 h-10 bg-red-600 rounded-lg flex items-center justify-center text-white font-bold text-lg" data-id="element-1992">
            Z
          </div>
          <div className="lg:block hidden" data-id="element-1993">
            <h1 className="text-lg font-bold text-gray-900" data-id="element-1994">ZoomInfo</h1>
            <p className="text-xs text-gray-500" data-id="element-1995">GTM Platform</p>
          </div>
        </div>
      </div>
      {/* Navigation */}
      <nav className="flex-1 px-3 py-4 overflow-y-auto" data-id="element-1996">
        <div className="space-y-1" data-id="element-1997">
          {menuSections.map(section => {
          const SectionIcon = section.icon;
          const isExpanded = expandedSections.includes(section.title);
          const hasActiveItem = section.subItems.some(item => location.pathname === item.path);
          const isActive = location.pathname === section.path;
          if (section.subItems.length === 0) {
            return <Link key={section.title} to={section.path || '/'} onClick={() => setIsMobileMenuOpen(false)} className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors ${isActive ? 'bg-red-50 text-red-600 font-medium' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-1998">
                  <SectionIcon className="w-5 h-5 flex-shrink-0" data-id="element-1999" />
                  <span className="text-sm flex-1 text-left lg:block hidden" data-id="element-2000">
                    {section.title}
                  </span>
                </Link>;
          }
          return <div key={section.title} data-id="element-2001">
                <button onClick={() => toggleSection(section.title)} className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors ${hasActiveItem ? 'bg-red-50 text-red-600 font-medium' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-2002">
                  <SectionIcon className="w-5 h-5 flex-shrink-0" data-id="element-2003" />
                  <span className="text-sm flex-1 text-left lg:block hidden" data-id="element-2004">
                    {section.title}
                  </span>
                  <span className="lg:block hidden" data-id="element-2005">
                    {isExpanded ? <ChevronDownIcon className="w-4 h-4" data-id="element-2006" /> : <ChevronRightIcon className="w-4 h-4" data-id="element-2007" />}
                  </span>
                </button>
                {isExpanded && <div className="ml-6 mt-1 space-y-1 lg:block hidden" data-id="element-2008">
                    {section.subItems.map(item => {
                const isActive = location.pathname === item.path;
                return <Link key={item.path} to={item.path} onClick={() => setIsMobileMenuOpen(false)} className={`flex items-center gap-3 px-3 py-2 rounded-lg transition-colors ${isActive ? 'bg-red-50 text-red-600 font-medium' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-2009">
                          <span className="text-sm" data-id="element-2010">{item.label}</span>
                        </Link>;
              })}
                  </div>}
              </div>;
        })}
        </div>
      </nav>
    </>;
  return <>
      {/* Mobile Menu Button */}
      <button onClick={() => setIsMobileMenuOpen(true)} className="lg:hidden fixed top-4 left-4 z-40 p-2 bg-white rounded-lg shadow-lg border border-gray-200 hover:bg-gray-50 transition-colors" data-id="element-2011">
        <MenuIcon className="w-6 h-6 text-gray-700" data-id="element-2012" />
      </button>
      {/* Mobile Overlay */}
      {isMobileMenuOpen && <div className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-40" onClick={() => setIsMobileMenuOpen(false)} data-id="element-2013" />}
      {/* Desktop Sidebar */}
      <div className="hidden lg:flex lg:w-64 bg-white border-r border-gray-200 h-screen flex-col" data-id="element-2014">
        <NavigationContent data-id="element-2015" />
      </div>
      {/* Mobile Icon-Only Bar */}
      <div className="lg:hidden w-16 bg-white border-r border-gray-200 h-screen flex flex-col" data-id="element-2016">
        <div className="px-3 py-5 border-b border-gray-200" data-id="element-2017">
          <div className="w-10 h-10 bg-red-600 rounded-lg flex items-center justify-center text-white font-bold text-lg" data-id="element-2018">
            Z
          </div>
        </div>
        <nav className="flex-1 px-2 py-4 overflow-y-auto" data-id="element-2019">
          <div className="space-y-1" data-id="element-2020">
            {menuSections.map(section => {
            const SectionIcon = section.icon;
            const hasActiveItem = section.subItems.some(item => location.pathname === item.path);
            const isActive = location.pathname === section.path;
            return <button key={section.title} onClick={() => setIsMobileMenuOpen(true)} className={`w-full flex items-center justify-center p-2.5 rounded-lg transition-colors ${hasActiveItem || isActive ? 'bg-red-50 text-red-600' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-2021">
                  <SectionIcon className="w-5 h-5" data-id="element-2022" />
                </button>;
          })}
          </div>
        </nav>
      </div>
      {/* Mobile Flyout Menu */}
      <div className={`lg:hidden fixed top-0 left-0 h-full w-64 bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-in-out ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'}`} data-id="element-2023">
        <div className="h-full flex flex-col" data-id="element-2024">
          {/* Close Button */}
          <div className="px-6 py-5 border-b border-gray-200 flex items-center justify-between" data-id="element-2025">
            <div className="flex items-center gap-3" data-id="element-2026">
              <div className="w-10 h-10 bg-red-600 rounded-lg flex items-center justify-center text-white font-bold text-lg" data-id="element-2027">
                Z
              </div>
              <div data-id="element-2028">
                <h1 className="text-lg font-bold text-gray-900" data-id="element-2029">ZoomInfo</h1>
                <p className="text-xs text-gray-500" data-id="element-2030">GTM Platform</p>
              </div>
            </div>
            <button onClick={() => setIsMobileMenuOpen(false)} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-2031">
              <XIcon className="w-5 h-5 text-gray-500" data-id="element-2032" />
            </button>
          </div>
          {/* Navigation Content */}
          <nav className="flex-1 px-3 py-4 overflow-y-auto" data-id="element-2033">
            <div className="space-y-1" data-id="element-2034">
              {menuSections.map(section => {
              const SectionIcon = section.icon;
              const isExpanded = expandedSections.includes(section.title);
              const hasActiveItem = section.subItems.some(item => location.pathname === item.path);
              const isActive = location.pathname === section.path;
              if (section.subItems.length === 0) {
                return <Link key={section.title} to={section.path || '/'} onClick={() => setIsMobileMenuOpen(false)} className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors ${isActive ? 'bg-red-50 text-red-600 font-medium' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-2035">
                      <SectionIcon className="w-5 h-5" data-id="element-2036" />
                      <span className="text-sm flex-1 text-left" data-id="element-2037">
                        {section.title}
                      </span>
                    </Link>;
              }
              return <div key={section.title} data-id="element-2038">
                    <button onClick={() => toggleSection(section.title)} className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors ${hasActiveItem ? 'bg-red-50 text-red-600 font-medium' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-2039">
                      <SectionIcon className="w-5 h-5" data-id="element-2040" />
                      <span className="text-sm flex-1 text-left" data-id="element-2041">
                        {section.title}
                      </span>
                      {isExpanded ? <ChevronDownIcon className="w-4 h-4" data-id="element-2042" /> : <ChevronRightIcon className="w-4 h-4" data-id="element-2043" />}
                    </button>
                    {isExpanded && <div className="ml-6 mt-1 space-y-1" data-id="element-2044">
                        {section.subItems.map(item => {
                    const isActive = location.pathname === item.path;
                    return <Link key={item.path} to={item.path} onClick={() => setIsMobileMenuOpen(false)} className={`flex items-center gap-3 px-3 py-2 rounded-lg transition-colors ${isActive ? 'bg-red-50 text-red-600 font-medium' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-2045">
                              <span className="text-sm" data-id="element-2046">{item.label}</span>
                            </Link>;
                  })}
                      </div>}
                  </div>;
            })}
            </div>
          </nav>
        </div>
      </div>
    </>;
}